/* eslint-disable no-underscore-dangle */
import { Subject } from 'rxjs'
import { take, tap } from 'rxjs/operators'

import { isNonProd } from './check-env'
import { getGlobalParams } from '../config/config'

/* istanbul ignore next */ window._dl = window._dl ? window._dl : {}
/* istanbul ignore next */ window._dl.content = window._dl.content ? window._dl.content : {}

/* istanbul ignore next */
const dispatchEvent = (options, dl) => /* istanbul ignore next */ {
  window._dl = dl ?? window._dl
  document.dispatchEvent(new CustomEvent('analytics', options))
  if (isNonProd()) {
    if (options.detail.type === 'pageview') {
      console.log(`[DISPATCH VIEW]: ${JSON.stringify(window._dl)}`)
    } else {
      console.log(`[DISPATCH EVENT]: ${JSON.stringify(options)}`)
    }
  }
}

const getFundPageDL = (/* istanbul ignore next */ pathname = window.location.pathname, removeLast = false) => {
  const { countryConfig } = getGlobalParams()
  const dl = {
    channel: 'wholesale',
    country: countryConfig?.common?.cc,
    language: countryConfig?.common?.locale,
    page_name: `fidtw:wholesale${decodeURI(pathname)
      .replace('fundui/', '')
      .replace(/(.+)\/$/, '$1')
      .replace(/\//g, ':')}`,
    site_section: pathname.split('/')[1] ?? 'General',
    spa: true
  }
  if (removeLast) {
    const arr = dl.page_name.split(':')
    dl.page_name = arr.slice(0, arr.length - 1).join(':')
  }
  dl.page_name = dl.page_name.replaceAll(':', ': ')
  return dl
}

const getFundComparePageDL = () => {
  const { countryConfig } = getGlobalParams()
  const dl = {
    channel: 'wholesale',
    country: countryConfig?.common?.cc,
    language: countryConfig?.common?.locale,
    page_name: 'fidtw: wholesale: fund-and-service: funds compare',
    site_section: 'fund-and-service',
    spa: true
  }
  return dl
}

const dispatchFundDetailPage = (
  content,
  product,
  /* istanbul ignore next */ pathname = window.location.pathname,
  /* istanbul ignore next */ noFire = false
) => {
  const matchedUrl = decodeURI(pathname).match(/funds\/(.+)\/|funds\/(.+)$/)
  if (Array.isArray(matchedUrl) && matchedUrl.length === 3) {
    const dl = {
      ...getFundPageDL(pathname, false),
      ...content,
      ...product
    }

    /* istanbul ignore next */
    if (!noFire) {
      dispatchEvent(
        {
          detail: {
            type: 'pageview'
          }
        },
        dl
      )
    }

    return dl
  }
  return null
}

const dispatchFundPage = (/* istanbul ignore next */ pathname = window.location.pathname, /* istanbul ignore next */ noFire = false) => {
  const dl = {
    ...getFundPageDL(pathname)
  }

  /* istanbul ignore next */
  if (!noFire) {
    dispatchEvent(
      {
        detail: {
          type: 'pageview'
        }
      },
      dl
    )
  }

  return dl
}

const dispatchFundDetailEvent = (action, content, /* istanbul ignore next */ noFire = false) => {
  const options = {
    detail: {
      type: 'event',
      action: 'global.interactionEvent',
      event_category: 'factsheet',
      event_action: action,
      event_content: content
    }
  }
  /* istanbul ignore next */
  if (!noFire) {
    dispatchEvent(options)
  }

  return options
}

const dispatchMonthlyDownloadEvent = (content, /* istanbul ignore next */ noFire = false) => {
  const options = {
    detail: {
      type: 'event',
      action: 'global.download',
      fileName: content
    }
  }
  /* istanbul ignore next */
  if (!noFire) {
    dispatchEvent(options)
  }

  return options
}

const dispatchFundCompareEvent = (action, content, /* istanbul ignore next */ noFire = false) => {
  const options = {
    detail: {
      type: 'event',
      action: 'global.interactionEvent',
      event_category: 'factsheet',
      event_action: action,
      event_content: content
    }
  }
  /* istanbul ignore next */
  if (!noFire) {
    dispatchEvent(options)
  }

  return options
}

const dispatchFundComparePage = (/* istanbul ignore next */ noFire = false) => {
  const dl = {
    ...getFundComparePageDL()
  }

  /* istanbul ignore next */
  if (!noFire) {
    dispatchEvent(
      {
        detail: {
          type: 'pageview'
        }
      },
      dl
    )
  }

  return dl
}

const dispatchFundListClickFund = (content, /* istanbul ignore next */ noFire = false) => {
  const options = {
    detail: {
      type: 'event',
      action: 'global.interactionEvent',
      event_category: 'fund filter',
      event_action: 'search success',
      event_content: content
    }
  }
  /* istanbul ignore next */
  if (!noFire) {
    dispatchEvent(options)
  }

  return options
}

const dispatchFundListFundType = (action, content, /* istanbul ignore next */ noFire = false) => {
  const options = {
    detail: {
      type: 'event',
      action: 'global.interactionEvent',
      event_category: 'fund filter',
      event_action: action,
      event_content: content
    }
  }
  /* istanbul ignore next */
  if (!noFire) {
    dispatchEvent(options)
  }

  return options
}

const dispatchFundListExpand = (content, /* istanbul ignore next */ noFire = false) => {
  const options = {
    detail: {
      type: 'event',
      action: 'global.interactionEvent',
      event_category: 'Fund Filter',
      event_action: 'Expand Collapse',
      event_content: content
    }
  }
  /* istanbul ignore next */
  if (!noFire) {
    dispatchEvent(options)
  }

  return options
}

const dispatchFundListGroupBy = (content, /* istanbul ignore next */ noFire = false) => {
  const options = {
    detail: {
      type: 'event',
      action: 'global.interactionEvent',
      event_category: 'Fund Filter',
      event_action: 'Grouped By',
      event_content: content
    }
  }
  /* istanbul ignore next */
  if (!noFire) {
    dispatchEvent(options)
  }

  return options
}

const dispatchFundListOrder = (action, content, /* istanbul ignore next */ noFire = false) => {
  const options = {
    detail: {
      type: 'event',
      action: 'global.interactionEvent',
      event_category: 'Fund Filter',
      event_action: action,
      event_content: content
    }
  }
  /* istanbul ignore next */
  if (!noFire) {
    dispatchEvent(options)
  }

  return options
}

const searchBoxOptions = {
  detail: {
    type: 'event',
    action: 'global.interactionEvent',
    event_category: 'fund filter',
    event_action: 'search',
    event_content: 'input'
  }
}
const $trackSequenceSearchBox = new Subject()
const $finalSequenceSearchBox = $trackSequenceSearchBox
  .pipe(
    tap(() => {
      dispatchEvent(searchBoxOptions)
    }),
    take(1)
  )
  .subscribe()

window.addEventListener('beforeunload', () => {
  $finalSequenceSearchBox.unsubscribe()
})

const dispatchFundListSearchBox = (/* istanbul ignore next */ noFire = false) => {
  /* istanbul ignore next */
  if (!noFire) {
    $trackSequenceSearchBox.next()
  }

  return searchBoxOptions
}

export {
  dispatchFundDetailPage,
  dispatchFundDetailEvent,
  dispatchFundPage,
  getFundPageDL,
  dispatchMonthlyDownloadEvent,
  dispatchFundCompareEvent,
  dispatchFundComparePage,
  dispatchFundListSearchBox,
  dispatchFundListFundType,
  dispatchFundListGroupBy,
  dispatchFundListExpand,
  dispatchFundListClickFund,
  dispatchFundListOrder
}
